import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;

export const initMixpanel = (): void => {
    if (!MIXPANEL_TOKEN) {
        console.warn("Mixpanel token is missing! Check your .env file.");
        return;
    }

    mixpanel.init(MIXPANEL_TOKEN, {
        autocapture: true,
        record_sessions_percent: 100, //records 100% of all sessions
        debug: true,
        track_pageview: true,
        persistence: "localStorage",
        record_heatmap_data: true,
    });
};

export const trackPageView = (url: string): void => {
    if (!MIXPANEL_TOKEN) {
        console.warn("Mixpanel token is missing! Check your .env file.");
        return;
    }
    mixpanel.track_pageview({ url });
};
